import Section from "../components/Section";

const FORMSPREE_ID = import.meta.env.VITE_FORMSPREE_ID;
const ACTION = FORMSPREE_ID ? `https://formspree.io/f/${FORMSPREE_ID}` : undefined;

export default function Contact() {
  return (
    <Section   title="Kontakt"
  subtitle={
    <>
      Bei Anliegen zu unseren Projekten, Auftragsanfragen oder sonstigen Fragen stehen wir Ihnen gern zur Verfügung.
      <br />
      Bitte füllen Sie das Kontaktformular mit Ihrem Anliegen aus – wir melden uns zeitnah.
    </>
  }
> <form
        action={ACTION}
        method="POST"
        className="mx-auto max-w-2xl rounded-2xl glass p-6 space-y-4"
        onSubmit={(e) => {
          if (!ACTION) {
            e.preventDefault();
            alert("Formspree-ID fehlt. Setze VITE_FORMSPREE_ID in .env und starte Vite neu.");
          }
        }}
      >
        <div>
          <label className="block text-sm text-slate-300">Name</label>
          <input name="name" required className="mt-1 w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 outline-none focus:ring-2 focus:ring-brand-500" placeholder="Dein Name" />
        </div>
        <div>
          <label className="block text-sm text-slate-300">E-Mail</label>
          <input name="email" type="email" required className="mt-1 w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 outline-none focus:ring-2 focus:ring-brand-500" placeholder="mail@example.com" />
        </div>
        <div>
          <label className="block text-sm text-slate-300">Nachricht</label>
          <textarea name="message" rows={6} required className="mt-1 w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 outline-none focus:ring-2 focus:ring-brand-500" placeholder="Worum geht’s?" />
        </div>

        {/* optional */}
        <input type="hidden" name="_subject" value="Kontaktformular – M2 Websolutions" />
        <input type="hidden" name="_next" value="https://m2websolutions.eu/kontakt?sent=1" />
        {/* Spam-Honeypot */}
        <input type="text" name="_gotcha" className="hidden" />

      
  <button
  type="submit"
  className="group inline-flex items-center justify-center gap-2 rounded-xl bg-black px-4 py-2 font-semibold text-white shadow-sm
             transition-colors duration-200 hover:bg-zinc-700 active:bg-zinc-600
             focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20 disabled:opacity-60"
>
  Senden
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    aria-hidden="true"
    className="opacity-80 transition-transform duration-200 group-hover:translate-x-0.5"
  >
    <path
      d="M5 12h12m-4-4l4 4-4 4"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
</button>




        <p className="text-xs text-slate-400">Deine Nachricht wird über Formspree an uns weitergeleitet.</p>
      </form>
    </Section>
  );
}
